export const TARGET_GIFT_DATE = 'target_gift_date';

export const mainProspectsSort = [
	{ label: 'Wisely Recommended', rule: { expected_value: -1 } },
	{ label: 'Largest Giving This Year', rule: { target_giving_amount: -1 } },
	{
		label: 'Next Gift Date (ascending)',
		rule: { [TARGET_GIFT_DATE]: 1 },
	},
	{
		label: 'Next Gift Date (descending)',
		rule: { [TARGET_GIFT_DATE]: -1 },
	},
];

export const recentGiftsSort = [
	{ label: 'Wisely Recommended', rule: { expected_value: -1 } },
	{ label: 'Date (ascending)', rule: { last_gift_date: 1 } },
	{ label: 'Date (descending)', rule: { last_gift_date: -1 } },
	{ label: 'Amount (ascending)', rule: { last_gift_amount: 1 } },
	{ label: 'Amount (descending)', rule: { last_gift_amount: -1 } },
];

export const atRiskSort = [
	{ label: 'Wisely Recommended', rule: { expected_value: -1 } },
	{ label: 'Last Gift Date (ascending)', rule: { last_gift_date: 1 } },
	{ label: 'Last Gift Date (descending)', rule: { last_gift_date: -1 } },
	{ label: 'Last Gift Amount (ascending)', rule: { last_gift_amount: 1 } },
	{ label: 'Last Gift Amount (descending)', rule: { last_gift_amount: -1 } },
];

export const prospectInitialState = {
	mainProspectsSort: mainProspectsSort[0],
	recentGiftsSort: recentGiftsSort[0],
	atRiskSort: atRiskSort[0],
};



// WEBPACK FOOTER //
// ./src/redux/prospects/prospect.initialState.js